import Login from 'i18n/en/Login';
import Offers from 'i18n/en/Offers';
import DatesUnits from 'i18n/en/DatesUnits';
import DownloadMobileApp from 'i18n/en/DownloadMobileApp';
import General from 'i18n/en/General.json';
import OfferDetail from 'i18n/en/OfferDetail';
import Jobs from 'i18n/en/Jobs';
import PendingJobDetail from 'i18n/en/PendingJobDetail';
import InTransitJobDetail from 'i18n/en/InTransitJobDetail';
import RecoverPassword from 'i18n/en/RecoverPassword';
import Chat from 'i18n/en/Chat';
import Banner from 'i18n/en/Banner';
import Alerts from 'i18n/en/Alerts';
import Pods from 'i18n/en/Pods';
import AccountSettings from 'i18n/en/AccountSettings';
import Documents from 'i18n/en/Documents';

const lang = {
  Login,
  Offers,
  DatesUnits,
  DownloadMobileApp,
  General,
  OfferDetail,
  Documents,
  Jobs,
  PendingJobDetail,
  InTransitJobDetail,
  RecoverPassword,
  Chat,
  Banner,
  Alerts,
  Pods,
  AccountSettings
};

export default lang;
